var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.posting)?_c('div',{staticClass:"sign-loading",style:({ 'backgroundColor': _vm.bgColor, 'position': _vm.position, 'margin-top': _vm.top })},[_c('img',{attrs:{"src":_vm.loadingImg[_vm.imgIndex + 1].url,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }